export const baseURL = '/sessions';

export const settings = {
  resultsPerPage: 25,
  defaultOrderBy: 'room',
  defaultOrder: 1 // 1=asc 0=desc
};
